// Aqui se centralizan los strings de las rutas al API
export class API {
    public static webApiBase = process.env.VUE_APP_ROOT_API;
    public static webApiBaseImages = process.env.VUE_APP_ROOT_PATH+'Images/';
    public static webApiBaseImagenes = process.env.VUE_APP_ROOT_PATH+'imagenes/';    
    public static webApiBaseinventario = process.env.VUE_APP_ROOT_PATH+'inventario/';
    public static webApiBaseactuaciones = process.env.VUE_APP_ROOT_PATH+'actuaciones/';
    public static webApiBaseRepositoriArchivos = process.env.VUE_APP_ROOT_PATH+'repositorio_archivos/';
    public static webApiBaseRootPath = process.env.VUE_APP_ROOT_PATH;//'/'
    
    public static login = API.webApiBase + 'Login';
    public static usuarios = API.webApiBase + 'Usuarios';
    public static roles = API.webApiBase + 'Roles';
    public static VersionBack = API.webApiBase + 'VersionBack';
    /*************************** */
    public static departamentos = API.webApiBase + 'departamentos';
    public static empresas = API.webApiBase + 'empresas';
    public static SendingEmails = API.webApiBase + 'SendingEmails';
    public static servidor_smtp = API.webApiBase + 'servidor_smtp';
    public static usuario = API.webApiBase + 'usuarios';
    public static pantalla_lista = API.webApiBase + 'pantalla_lista';
    public static enumeracion = API.webApiBase + 'enumeraciones';
    public static grupo_usuario = API.webApiBase + 'grupo_usuarios';
    public static Connect = API.webApiBase + 'Connect';
    public static cambioscontrasenasperdidas = API.webApiBase + 'cambioscontrasenasperdidas';
    public static categoria_invetario = API.webApiBase + 'categoria_invetario';
    public static invetario = API.webApiBase + 'inventario';
    public static rol = API.webApiBase + 'roles';
    public static mantenimiento_permiso = API.webApiBase + 'mantenimiento_permisos';
    public static permiso = API.webApiBase + 'permiso';
    public static TestAvatar = API.webApiBase + 'TestAvatar';
    public static menu_option = API.webApiBase + 'menu_options';
    public static ambito = API.webApiBase + 'ambitos';
    public static plan = API.webApiBase + 'planes';
    public static contador = API.webApiBase + 'contadores';
    public static objetivo = API.webApiBase + 'objetivos';
    public static actuacion = API.webApiBase + 'actuaciones';
    public static tarea = API.webApiBase + 'tareas';
    public static notificaciones = API.webApiBase + 'notificaciones';
    public static DashBoard = API.webApiBase + 'DashBoard';
    public static ticket = API.webApiBase + 'tickets';
    public static cliente = API.webApiBase + 'clientes';
    public static kpis_actuacion = API.webApiBase + 'kpis_actuacion';
    public static mediciones_kpi = API.webApiBase + 'mediciones_kpis';
    public static RepositorioInformes = API.webApiBase + 'RepositorioInformes';
    public static Oversee = API.webApiBase + 'Oversee';
    public static dinamically_form = API.webApiBase + 'dinamically_form';
    public static public = API.webApiBase + 'public';
    public static form_item = API.webApiBase + 'form_item';
    public static datos_reloj_corazon = API.webApiBase + 'datos_reloj_corazon';
    public static producto = API.webApiBase + 'productos';
    public static pedido = API.webApiBase + 'pedidos';
    public static lecturas_codigo_barras = API.webApiBase + 'lecturas_codigo_barras';
    public static TiendaOnlineClientes = API.webApiBase + 'TiendaOnlineClientes';
    public static datos_adicionales_producto = API.webApiBase + 'datos_adicionales_producto';
    public static qrs = API.webApiBase + 'qrs';
    public static qr_scans = API.webApiBase + 'qr_scans';
    public static clients = API.webApiBase + 'clients';
    public static carts = API.webApiBase + 'carts';
    public static cartItems = API.webApiBase + 'cart_items';
    public static productoByLpn = API.webApiBase + 'productos/by-lpn/';
    public static notas_cliente = API.webApiBase + 'notas_cliente';
    public static dashboardstats = API.webApiBase + 'DashboardStats';
    public static telemetria_cliente = API.webApiBase + 'telemetria_cliente';
    public static telemetria_cliente_by_client = API.webApiBase + 'telemetria_cliente/by_client/';
    public static publicarCarritoWordpress = API.webApiBase + 'WordpressLote/publicar-carrito/';
    public static generarCollageCarrito    = API.webApiBase + 'WordpressLote/generar-collage/';
    public static wordpressSuite           = API.webApiBase + 'WordpressSuite/';
    public static wordpressSuiteGenerarSeo = API.webApiBase + 'WordpressSuite/generar-seo';
    public static telemetria_top_busquedas = API.webApiBase + 'telemetria_cliente/top-busquedas';
    public static telemetria_top_productos = API.webApiBase + 'telemetria_cliente/top-productos';
    public static chatIA           = API.webApiBase + 'ChatIA/';
    public static chatPrompts      = API.webApiBase + 'ChatPrompts/';
    public static chatMemoria      = API.webApiBase + 'ChatMemoria/';
    public static xiaoZhi          = API.webApiBase + 'XiaoZhi/';
    public static chatIaConfig     = API.webApiBase + 'chat_ia_config';
    public static chatConversacion = API.webApiBase + 'chat_conversacion';
    public static chatMensaje      = API.webApiBase + 'chat_mensaje';
    public static perfil_comportamiento_cliente = API.webApiBase + 'perfil_comportamiento_cliente/';
    public static ventas_cabecera = API.webApiBase + 'ventas_cabecera/';
    public static ventas_lineas = API.webApiBase + 'ventas_lineas/';
    public static productosVenderVenta = API.webApiBase + 'productos/vender-venta/';
    public static crm_oportunidades = API.webApiBase + 'crm_oportunidades/';
    public static crm_actividades = API.webApiBase + 'crm_actividades/';
    //public static Licencia = API.webApiBase + 'Licencia';
    //public static Licencia = API.webApiBase + 'Licencia';
    //public static Licencia = API.webApiBase + 'Licencia';
    //public static Licencia = API.webApiBase + 'Licencia';
    //public static Licencia = API.webApiBase + 'Licencia';
    //public static Licencia = API.webApiBase + 'Licencia';



}
